import { render, staticRenderFns } from "./AtlasLogo.vue?vue&type=template&id=7130489a&scoped=true"
import script from "./AtlasLogo.vue?vue&type=script&lang=js"
export * from "./AtlasLogo.vue?vue&type=script&lang=js"
import style0 from "./AtlasLogo.vue?vue&type=style&index=0&id=7130489a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7130489a",
  null
  
)

export default component.exports